/* eslint-disable */

import StatusIndicator from "../status-indicator/status-indicator";
import ModelTag from "../model-tag/model-tag";

const ModelComponentTicket = ({ id, statusTitle }) => {
  return (
    <div
      className={`flex flex-col w-full gap-2  p-4 rounded-lg border-l-2 
        dark:border-color-dark-model-ticket border-color-model-ticket
        dark:bg-color-dark-background-secondary bg-color-background-secondary`}
    >
      <ModelTag modelId={id} isSmall={true} />
      <StatusIndicator
        title={statusTitle}
        statusColor={"bg-color-status-good"}
      />
    </div>
  );
};

export default ModelComponentTicket;
